"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSwitchFromMaturityToDirectDebitWithEstimateBody = exports.buildSwitchFromMaturityToDirectDebitBody = void 0;
function transformNumberOfPeople(numberOfPeople) {
    switch (numberOfPeople) {
        case '3-4':
            return '4';
        case '5-7':
            return '6';
        case '+7':
            return '8';
        default:
            var val = parseInt(numberOfPeople);
            if (isNaN(val) || val <= 0) {
                return '8';
            }
            return numberOfPeople;
    }
}
/**
 * Construit le body pour une requet de passage du prélèvement à échéance vers le prélèvement automatique
 * @param billingAgreementState State contenant les informations sur l'IBAN
 * @param payload Les autres paramètres pour réaliser le changement
 * @returns Un objet json bien formaté
 */
function buildSwitchFromMaturityToDirectDebitBody(billingAgreementState, payload) {
    if (!billingAgreementState.iban.numberOfPeople ||
        !billingAgreementState.iban.withdrawalDate ||
        !billingAgreementState.iban.value)
        return null;
    var body = {
        iban: billingAgreementState.iban.value,
        numberbOfPeople: transformNumberOfPeople(billingAgreementState.iban.numberOfPeople),
        debitDate: billingAgreementState.iban.withdrawalDate,
        dematerialization: payload.Ebill,
        sectionSubscriptionId: payload.sectionSubscriptionId,
        clientId: payload.ClientId,
        customerAccountId: payload.customerAccountId
    };
    return body;
}
exports.buildSwitchFromMaturityToDirectDebitBody = buildSwitchFromMaturityToDirectDebitBody;
function buildSwitchFromMaturityToDirectDebitWithEstimateBody(billingAgreementState, payload) {
    if (!billingAgreementState.iban.withdrawalDate ||
        !billingAgreementState.iban.value)
        return null;
    var body = {
        iban: billingAgreementState.iban.value,
        debitDate: billingAgreementState.iban.withdrawalDate,
        dematerialization: payload.Ebill,
        sectionSubscriptionId: payload.sectionSubscriptionId,
        clientId: payload.ClientId,
        customerAccountId: payload.customerAccountId,
        monthlyEstimation: payload.monthlyEstimation
    };
    return body;
}
exports.buildSwitchFromMaturityToDirectDebitWithEstimateBody = buildSwitchFromMaturityToDirectDebitWithEstimateBody;
